import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function relatorioIndicadorTempoRespostaFaixaReducer(state = initialState.relatorioIndicadorTempoRespostaFaixa, action){
    switch(action.type) {
        case types.RELAT_INDICADOR_TEMPO_RESPOSTA_FAIXA:
            
            return action.relatorioIndicadorTempoRespostaFaixa;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/relatorioIndicadorTempoRespostaFaixaReducer.js
 **/